
import { Component, Vue, Watch } from 'vue-property-decorator'
import { RouteRecord, Route } from 'vue-router'

@Component({
    name: 'Breadcrumb'
})
export default class extends Vue {
    private breadcrumbs: RouteRecord[] = []

    @Watch('$route')
    private onRouteChange(route: Route) {
        // if you go to the redirect page, do not update the breadcrumbs
        if (route.path.startsWith('/redirect/')) {
            return
        }
        this.getBreadcrumb()
    }

    created() {
        this.getBreadcrumb()
    }

    private getBreadcrumb() {
        let matched = this.$route.matched.filter((item) => {
            return item.meta && item.meta.title && item.meta.breadcrumb !== false
        })

        this.breadcrumbs = matched.reduce((prev: RouteRecord[], cur: RouteRecord) => {
            const isExist = prev.find(n => n.meta.title === cur.meta.title)
            if (isExist) {
                return prev
            }
            prev.push(cur)
            return prev
        }, []) 
    }

    private isDashboard(route: RouteRecord) {
        const name = route && route.name
        if (!name) {
            return false
        }
        return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    }

    private handleLink(item: any) {
        const { redirect, path } = item
        this.$router.push(redirect || path || '/')
    }
}
